import { AlertPolygonObject } from '@core_n/alert-polygon/alert-polygon.component';
import { UserActionMsg } from '@core_n/msg/msgs';
import * as projConsts from '../common/projConsts';
import * as projEnums from '../common/projEnums';
import * as enums from '@core_n/common/enums';

export class SetDoubleFlagMsg extends UserActionMsg {
  trackId: number;
  value: boolean;
  source: projEnums.FieldSource;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_SET_DOUBLE_FLAG;
  }
}

export class ResetBiasesMsg extends UserActionMsg {
  systemId: number;
  source: projEnums.FieldSource;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_RESET_BIASES;
  }
}

export class UnregisterMsg extends UserActionMsg {
  systemId: number;
  source: projEnums.FieldSource;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_UNREGISTER;
  }
}

//NEW SWITCH ACTIONS
export class CreateTrack extends UserActionMsg {
  LocationLat: number;
  LocationLong: number;
  LocationAlt: number;
  Heading: number;
  VelocityXYZ: number;
  TrackType: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_CREATE_TRACK;
  }
}

export class DropTrack extends UserActionMsg {
  TrackNumber: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_DROP_TRACK;
  }
}

export class UpdateTrack extends UserActionMsg {
  //TBD...!

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_UPDATE_TRACK;
  }
}

export class MergeTracks extends UserActionMsg {
  FirstTrackNumber: number;
  SecondTrackNumber: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_MERGE_TRACK;
  }
}

export class SetClassification extends UserActionMsg {
  TrackNumber: number;
  TrackIdentity: number;
  OperatorCategory: string;
  OperatorPlatform: string;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_SET_CLASSIFICATION;
  }
}

export class SetHostility extends UserActionMsg {
  TrackNumber: number;
  TrackHostility: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_SET_HOSTILITY;
  }
}

export class Nai extends UserActionMsg {
  AlertPolygonObj: AlertPolygonObject;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_NAINAT;
  }
}

export class ThreatBase extends UserActionMsg {
  //TBD...!

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_THREAT_BASE;
  }
}

export class SetRadarParameters extends UserActionMsg {
  //TBD...!

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_SET_RADAR_PARAMETERS;
  }
}

export class AssociateTrackForRegistration extends UserActionMsg {
  FirstTrackNumber: number;
  SecondTrackNumber: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_ASSOCIATE_TRACKS_FOR_REGISTRATION;
  }
}

export class ForbidDeletion extends UserActionMsg {
  TrackNumber: number;
  Forbid: boolean = false;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_FORBID_DELETION;
  }
}

export class GetSensors extends UserActionMsg {
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_GET_SENSORS;
  }
}

export class GetTracks extends UserActionMsg {
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_GET_TRACKS;
  }
}

export class GetHeight extends UserActionMsg {
  LocationLat: number;
  LocationLong: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_GET_HEIGHT;
  }
}

export class GetClsArm extends UserActionMsg {
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_GET_CLSARM;
  }
}


export class ExtIp extends UserActionMsg {
  Id: number;
  OperationAction: number;
  LocationLat: number;
  LocationLong: number;
  Radius: number;
  ImpactTime: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_EXTIP;
  }
}

export class SetSensor extends UserActionMsg {
  Sic: number;
  Sac: number;
  Credibility: number;
  CredibilityType: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_SET_SENSOR;
  }
}

export class ClientInit extends UserActionMsg {
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_CLIENT_INIT;
  }
}

export class ForceSendToSmart extends UserActionMsg {
  TrackNumber: number;

  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_FORCE_SEND_TO_SMART;
  }
}

export class CredibilityObj {
  // Flags
  isCredDefined: boolean = false;
  isShapeDefined: boolean = false;

  // Main Data
  Credibility: number;
  CredibilityType: number;
  GeometricShape: projEnums.GeometricShape;

  // Circle
  CircleRadius: number;
  CircleLatitude: number;
  CircleLongitude: number;

  // Polygon
  PolygonPoints: PolygonPoint[];
}

//for plyback
export class StartPlaybackMode extends UserActionMsg {
  dateTime: number;
  
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_START_PLAYBACK;
  }
}

export class PlaybackSpeedMode extends UserActionMsg {
  PlayBackSpeed: number;
  Jump: number;
  
  constructor() {
    super();
    this.SwitchAction = projConsts.USER_ACTION_PLAYBACK_SPEED;
  }
}

class PolygonPoint {
  Lat: number;
  Long: number;
}

